import { Box, Chip, Stack, Typography } from '@mui/material'
import { AppConnectionCardHeroBranding, AppConnectionCardHeroConnector } from './AppConnectionCardHeroBranding'
import { AppConnectionCardHeroAppAvatar } from './AppConnectionCardHeroAppAvatar'
import { heroConnectorWidth } from './appConnectionCardConstants.js'

export function AppConnectionCardHero({ safeTitle, iconUrl, showConnectedChrome }) {
  const statusLabel = showConnectedChrome ? null : `Connect to ${safeTitle}`

  return (
    <Stack
      sx={{
        width: '100%',
        fontFamily: 'var(--app-font-sans)',
        bgcolor: 'var(--app-bg-hover)',
        px: '14px',
        pt: '12px',
        pb: '12px',
        gap: '13px',
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{ width: '100%', minWidth: 0, gap: 0.75, justifyContent: 'flex-start' }}
      >
        <AppConnectionCardHeroBranding />
        <Stack
          sx={{
            flex: 1,
            minWidth: 0,
            maxWidth: heroConnectorWidth,
            alignItems: 'stretch',
            gap: '6px',
          }}
        >
          {statusLabel ? (
            <Typography
              variant="body2"
              title={statusLabel}
              sx={{
                width: '100%',
                minWidth: 0,
                fontWeight: 600,
                fontSize: '12px',
                lineHeight: 1.3,
                color: 'var(--app-text-tertiary)',
                fontFamily: 'inherit',
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {statusLabel}
            </Typography>
          ) : (
            <Box sx={{ width: '100%', minHeight: '16px' }} aria-hidden />
          )}
          <AppConnectionCardHeroConnector />
        </Stack>
        <AppConnectionCardHeroAppAvatar safeTitle={safeTitle} iconUrl={iconUrl} />
        {showConnectedChrome ? (
          <Chip
            label="Connected"
            color="success"
            variant="outlined"
            size="small"
            aria-label="Connection status: Connected"
            sx={{
              ml: 'auto',
              textTransform: 'none',
              fontWeight: 600,
              height: 26,
              flexShrink: 0,
              fontFamily: 'inherit',
            }}
          />
        ) : null}
      </Stack>
    </Stack>
  )
}
